import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import Index from "./components/dashboard/Index";
import Home from "./components/Home";
import Navbar from "./components/Navbar";

import Profile from "./components/auth/Profile";
import ProtectedRoute from "./components/auth/ProtectedRoutes";
import Login from "./components/auth/Login";
import Register from "./components/auth/Register";
import ForgotPassword from "./components/auth/ForgotPassword";
import ResetPassword from "./components/auth/ResetPassword";
import SubjectTree from "./components/subject/SubjectTree";

const App: React.FC = () => {
  return (
    <Router>
      <div className="site-navbar-wrap">
        <Navbar />
      </div>
      <Routes>
        <Route path="/home" element={<Home />} />
        <Route path="/dashboard" element={<Index />} />
        <Route path="/" element={<SubjectTree />} />
        <Route path="/:type/:title/:id" element={<Home />} />

        <Route path="/login" element={<Login />} />
        <Route path="/login/:token" element={<Login />} />
        <Route path="/signup" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />

        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
